module.exports = __webpack_public_path__ + "media/ישראל.445a5bb6.mp3";